import {store} from '../lib/store'
import {api} from '../lib/api'

export function systemComment(action) {
	if (action == 'approved') {
		return 'Согласовано'
	}
	else if (action == 'sent_to_approve') {
		return 'Заявка отправлена на утверждение'
	}
	else if (action == 'created') {
		return 'Заявка создана'
	}
	else if (action == 'clone_created') {
		return 'Заявка создана копированием'
	}
	else if (action == 'withdraw') {
		return 'Решение отозвано'
	}
	else if (action == 'changed') {
		return 'Заявка изменена'
	}
	else if (action == 'rejected') {
		return 'Отклонено'
	}
	else if (action == 'po_created') {
		return 'Ордер на оплату создан'
	}
	else if (action == 'pre_po_created') {
		return 'Все ордера на предоплату созданы'
	}
	else if (action == 'post_po_created') {
		return 'Все ордера на постоплату созданы'
	}
	else if (action == 'prepaid') {
		return 'Предоплата отправлена'
	}
	else if (action == 'postpaid') {
		return 'Постоплата отправлена'
	}
	else if (action == 'cashpaid') {
		return 'Сумма выдана'
	}
	else if (action == 'cashprepaid') {
		return 'Аванс выдан'
	}
	else if (action == 'cashpostpaid') {
		return 'Расчет произведен'
	}
	else if (action == 'drop') {
		return 'Согласования сброшены'
	}
	else if (action == 'drop_to_pu') {
		return 'Согласования сброшены до отдела закупок'
	}
	else if (action == 'closed') {
		return 'Заявка закрыта'
	}
	else if (action == 'charged') {
		return 'Выплата начислена'
	}
	else if (action == 'goods_ordered') {
		return 'Заказ оформлен'
	}
	else if (action == 'service_ordered') {
		return 'Услуга заказана'
	}
	else if (action == 'goods_received') {
		return 'Товар получен'
	}
	else if (action == 'service_received') {
		return 'Услуга получена'
	}
	else if (action == 'cash_spent') {
		return 'Сумма израсходована, чеки сданы'
	}
	else if (action == 'docs_checked') {
		return 'Документы получены'
	}
	else if (action == 'checks_checked') {
		return 'Чеки получены'
	}
}
export function systemIcon(action) {
	if (action == 'approved'
		|| action == 'sent_to_approve'
		|| action == 'pre_po_created'
		|| action == 'post_po_created'
		|| action == 'prepaid'
		|| action == 'postpaid'
		|| action == 'paid'
		|| action == 'cashpaid'
		|| action == 'cashprepaid'
		|| action == 'cashpostpaid'
		|| action == 'charged'
		|| action == 'goods_ordered'
		|| action == 'service_ordered'
		|| action == 'goods_received'
		|| action == 'service_received'
		|| action == 'cash_spent'
		|| action == 'docs_checked'
		|| action == 'checks_checked'
	) {
		return {
			name: 'check_circle',
			color: 'green'
		}
	}
	else if (
		action == 'rejected'
		|| action == 'closed'
	) {
		return {
			name: 'remove_circle',
			color: 'red'
		}
	}
	else if (action == 'withdraw') {
		return {
			name: 'undo',
			color: 'white'
		}
	}
	else if (action == 'changed'
		|| action == 'clone_created'
	) {
		return {
			name: 'edit',
			color: 'deep-orange'
		}
	}
	else {
		return {
			name: '',
			color: ''
		}
	}
}
